module.exports = __webpack_public_path__ + "static/media/user1.ebcac1be.png";